import { useMailingRepository } from '@Hooks/useRepository';
import { type EnumMailingSettingGroup } from '@Model';
import { EmailsRepository } from '@Repositories/Mailing';
import { unwrapOr } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useGetMailingPlaceholders(settingName: EnumMailingSettingGroup, enabled = true) {
    const emails = useMailingRepository(EmailsRepository);

    const query = useQuery({
        queryFn: () => emails.getPlaceholders(settingName),
        queryKey: ['mailing', 'placeholders', settingName],
        enabled,
    });

    return useMemo(
        () => ({
            placeholders: unwrapOr(query.data, []),
            isLoading: query.isLoading,
        }),
        [query.data, query.isLoading],
    );
}
